import { render } from "./TopWriter.vue?vue&type=template&id=5dd8bd55"
import script from "./TopWriter.vue?vue&type=script&lang=js"
export * from "./TopWriter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__